module.exports = __webpack_public_path__ + "static/media/report.fc64dec2.svg";